/* eslint-disable react/jsx-no-target-blank */
import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import Header from '../components/layout/Header'
import Footer from '../components/layout/Footer'
import { FaArrowRight } from 'react-icons/fa'
import { Calendar3, Clock, GeoAlt } from 'react-bootstrap-icons'
import axios from 'axios'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import ReCAPTCHA from 'react-google-recaptcha'
import { Helmet } from 'react-helmet'

const EventDetail = () => {
    const { slug } = useParams()

    const [event, setEvent] = useState(null)
    const [upcomming, setUpcomming] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [phone, setPhone] = useState('')
    const [comment, setComment] = useState('')
    // const [nameError, setNameError] = useState('')
    // const [emailError, setEmailError] = useState('')
    // const [phoneError, setPhoneError] = useState('')
    // const [captchaError, setCaptchaError] = useState('')

    useEffect(() => {
        window.scrollTo(0, 0)
        axios
            .get(`${process.env.REACT_APP_API_URL}/events/slug/${slug}`)
            .then((res) => {
                setEvent(res.data)
                setLoading(false)
            })
            .catch((err) => {
                console.error('Error fetching event:', err)
                setError('Unable to load event details.')
                setLoading(false)
            })

        // Fetch upcoming events
        axios
            .get(`${process.env.REACT_APP_API_URL}/events/upcomming`)
            .then((res) => {
                const events = res.data?.events || []
                setUpcomming(events)
            })
            .catch((err) => {
                console.error('Error fetching upcoming events:', err)
                setError('Unable to load upcoming events.')
            })
    }, [slug])

    const handleSendForm = (e) => {
        e.preventDefault()
        // Implement form submission logic here
    }

    const handleNameBlur = () => {
        // Implement name validation logic here
    }

    const handleEmailBlur = () => {
        // Implement email validation logic here
    }

    const handlePhoneBlur = () => {
        // Implement phone validation logic here
    }

    const onChange = (value) => {
        // Implement ReCAPTCHA change logic here
    }

    if (loading) return <p className="text-center text-white">Loading event details...</p>
    if (error) return <p className="text-center text-danger mt-5">{error}</p>
    if (!event) return null

    const formatDate = (dateStr) => {
        const options = { year: 'numeric', month: 'short', day: 'numeric' }
        return new Date(dateStr).toLocaleDateString(undefined, options)
    }
    const formatTime = (timeStr) => {
        const [hour, minute] = timeStr.split(':')
        const date = new Date()
        date.setHours(hour, minute)
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    }

    return (
        <>
        <Helmet>
            <title>
                {event.title} | 800 Homes
            </title>
        </Helmet>
            <Header />
            <section id="website-responsive" className="container-fluid py-5 border-top border-1 border-white">
                <div className="row justify-content-evenly gy-5">
                    <div className="col-11 col-md-7 px-0">
                        <div className="border-white border-1 border mb-4 bg-white">
                            <img src={event.image} alt={event.title} className="w-100" />
                            <div className="p-4 text-dark mt-md-4 mt-2">
                                <h2 className="text-ss-primary fs-ss-28 fw-600 mb-4">{event.title}</h2>

                                <div className="event-meta d-flex flex-column mb-4">
                                    <div className="d-md-flex justify-content-start mb-md-3">
                                        <div className="d-flex align-items-start w-50">
                                            <Calendar3 className="me-2" size={14} />
                                            <div>
                                                {event.occurrence === 'recurring' ? (
                                                    event.recurrence_days?.length > 0 && (
                                                        <>
                                                            <span className="fw-700">Recurring on every: </span>{' '}
                                                            {event.recurrence_days.join(', ')}
                                                        </>
                                                    )
                                                ) : (
                                                    <>
                                                        {event.type === 'single' && (
                                                            <>
                                                                <span className="fw-700">Date:</span>{' '}
                                                                {formatDate(event.from_date)}
                                                            </>
                                                        )}
                                                        {event.type === 'multi' && (
                                                            <>
                                                                <span className="fw-700">Date:</span>{' '}
                                                                {formatDate(event.from_date)} -{' '}
                                                                {formatDate(event.to_date)}
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-start py-md-0 py-2">
                                            <Clock className="me-2" style={{ marginTop: '2px' }} size={14} />
                                            <div>
                                                {event.from_time && event.to_time && (
                                                    <div>
                                                        <span className="fw-700">Time:</span>{' '}
                                                        {formatTime(event.from_time)} - {formatTime(event.to_time)}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-start">
                                        <div className="">
                                            <GeoAlt className="me-2" style={{ marginTop: '2px' }} size={14} />
                                        </div>
                                        <div>{event.venue_address}</div>
                                    </div>
                                </div>

                                <div
                                    className="mb-4 text-dark"
                                    dangerouslySetInnerHTML={{ __html: event.description }}
                                />

                                {event.highlights?.length > 0 && (
                                    <>
                                        <h3 className="text-ss-secondary fw-bold mb-3">Event Highlights</h3>
                                        <ul className="mb-4 text-dark">
                                            {event.highlights.map((highlight, idx) => (
                                                <li key={idx} className="mb-2">
                                                    {highlight}
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                )}
                            </div>
                        </div>

                        {event?.venue_link && (
                            <div className="location-events">
                                <div
                                    className=""
                                    style={{ height: '100%' }}
                                    dangerouslySetInnerHTML={{ __html: event.venue_link }}
                                />
                            </div>
                        )}
                    </div>

                    <div className="col-11 col-md-3 px-0">
                        <div className="sticky-top" style={{ top: '20px' }}>
                            <div className="border-white border-1 border p-4 mb-4">
                                <section className="container-fluid bg-grey-2 rounded-0 px-0">
                                    <div className="row justify-content-center align-items-center">
                                        <div className="col-12">
                                            <div className="fs-ss-22 fw-500 lh-sm text-white pb-4 text-center">
                                                Inquiry - 800 Homes
                                            </div>
                                            <div className="">
                                                <form
                                                    onSubmit={handleSendForm}
                                                    id="contactForm"
                                                    method="POST"
                                                    action="#"
                                                    className=""
                                                >
                                                    <div className="form-group mb-3">
                                                        <input
                                                            type="text"
                                                            className={`form-control text-grey fs-ss-16 fw-300 ${
                                                                // nameError ? 'is-invalid' :
                                                                ''
                                                            }`}
                                                            id="name"
                                                            name="name"
                                                            placeholder="Name *"
                                                            required
                                                            value={name}
                                                            onChange={(e) => setName(e.target.value)}
                                                            onBlur={handleNameBlur}
                                                        />
                                                        {/* {nameError && (
                                                            <div className="invalid-feedback">{nameError}</div>
                                                        )} */}
                                                    </div>
                                                    <div className="form-group mb-3">
                                                        <input
                                                            type="email"
                                                            className={`form-control text-grey fs-ss-16 fw-300 ${
                                                                // emailError ? 'is-invalid' :
                                                                ''
                                                            }`}
                                                            id="email"
                                                            name="email"
                                                            placeholder="Email *"
                                                            required
                                                            value={email}
                                                            onChange={(e) => setEmail(e.target.value)}
                                                            onBlur={handleEmailBlur}
                                                        />
                                                        {/* {emailError && (
                                                            <div className="invalid-feedback">{emailError}</div>
                                                        )} */}
                                                    </div>
                                                    <div className="form-group mb-3">
                                                        <PhoneInput
                                                            country={'ae'}
                                                            value={phone}
                                                            onChange={(phone) => setPhone(phone)}
                                                            onBlur={handlePhoneBlur}
                                                            inputProps={{
                                                                name: 'phone_number',
                                                                id: 'phone_number',
                                                                required: true,
                                                                className: `w-100 bg-transparent rounded-0 border-bottom border-0 border-white text-grey fs-ss-16 fw-300 ps-5 ${
                                                                    // phoneError ? 'is-invalid' :
                                                                    ''
                                                                }`,
                                                                placeholder: 'Phone Number *',
                                                            }}
                                                            containerStyle={{
                                                                width: '100%',
                                                            }}
                                                            enableSearch={true}
                                                            buttonStyle={{
                                                                backgroundColor: 'transparent',
                                                                border: 'none',
                                                            }}
                                                            dropdownStyle={{
                                                                width: '300px',
                                                            }}
                                                        />
                                                        {/* {phoneError && (
                                                            <div className="invalid-feedback d-block">{phoneError}</div>
                                                        )} */}
                                                    </div>
                                                    <div className="form-group mb-4">
                                                        <textarea
                                                            className="form-control text-grey fs-ss-16 fw-300"
                                                            value={comment}
                                                            onChange={(e) => setComment(e.target.value)}
                                                            id="message"
                                                            name="message"
                                                            rows="4"
                                                            placeholder="Message"
                                                        ></textarea>
                                                    </div>
                                                    <div className="">
                                                        <ReCAPTCHA
                                                            sitekey="6LdX3UgqAAAAAMWqmjHfeiVGKr_oLcfyYrNEu8KH"
                                                            onChange={onChange}
                                                        />
                                                        {/* {captchaError && (
                                                            <div className="text-danger mb-2">{captchaError}</div>
                                                        )} */}
                                                        <button
                                                            className="mt-2 text-center text-white fw-300 bg-ss-primary bg-hover-ss-primary rounded-0 border-0 text-ss-secondary fs-ss-16 px-3 py-ss-2 w-100"
                                                            id="submit-btn"
                                                            type="submit"
                                                        >
                                                            Submit
                                                        </button>
                                                    </div>
                                                </form>
                                                <div className="d-flex">
                                                    <div className="w-50 pe-1">
                                                        <a
                                                            href="tel:+971585746637"
                                                            className="d-block text-decoration-none mt-2 text-center text-white fw-300 border-ss-primary bg-hover-ss-primary rounded-0 fs-ss-16 px-3 py-ss-2 w-100"
                                                        >
                                                            Call
                                                        </a>
                                                    </div>
                                                    <div className="w-50 ps-1">
                                                        <a
                                                            target="_blank"
                                                            href="https://api.whatsapp.com/send/?phone=971585746637&text&type=phone_number&app_absent=0"
                                                            className="d-block text-decoration-none mt-2 text-center text-white fw-300 border-ss-primary bg-hover-ss-primary rounded-0 fs-ss-16 px-3 py-ss-2 w-100"
                                                        >
                                                            WhatsApp
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div className="border-white border-1 border p-4 mt-4">
                                <h4 className="text-ss-primary fw-bold mb-4">Upcoming Events</h4>
                                {upcomming && upcomming.length > 0 ? (
                                    upcomming.map((event, index) => (
                                        <div
                                            key={event._id}
                                            className={`upcoming-event ${
                                                index !== upcomming.length - 1
                                                    ? 'mb-3 pb-3 border-1 border-white border-bottom'
                                                    : ''
                                            }`}
                                        >
                                            <h5 className="fs-ss-18 fw-500 mb-2 text-white mt-4">{event.title}</h5>

                                            <div className="d-flex align-items-center text-white small mb-2">
                                                <Calendar3 className="me-2" style={{ marginTop: '2px' }} size={14} />
                                                <div>
                                                    {event.occurrence === 'recurring' ? (
                                                        event.recurrence_days?.length > 0 && (
                                                            <>
                                                                <span className="fw-700">Recurring on every:</span>{' '}
                                                                {event.recurrence_days.join(', ')}
                                                            </>
                                                        )
                                                    ) : (
                                                        <>
                                                            {event.type === 'single' && (
                                                                <>
                                                                    <span className="fw-700">Date:</span>{' '}
                                                                    {formatDate(event.from_date)}
                                                                </>
                                                            )}
                                                            {event.type === 'multi' && (
                                                                <>
                                                                    <span className="fw-700">Date:</span>{' '}
                                                                    {formatDate(event.from_date)} -{' '}
                                                                    {formatDate(event.to_date)}
                                                                </>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                            <Link
                                                to={`/events/${event.slug}`}
                                                className="text-ss-primary d-flex align-items-center mt-2 text-decoration-none fs-ss-15"
                                            >
                                                <span>View Details</span>
                                                <FaArrowRight className="ms-2" size={12} />
                                            </Link>
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-white text-center py-3">No upcoming events</div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default EventDetail
